import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

/* eslint-disable no-console */
export default (TAG: string, message: unknown): void => {
  if (['qa', 'test', 'stage', 'prod', 'production'].includes(publicRuntimeConfig.QUILLBOT_ENV)) {
    return;
  }
  console.group(TAG);
  if (message instanceof Array) {
    message.forEach((ele) => {
      console.info(ele);
    });
  } else console.info(message);
  console.groupEnd();
};
